import React, { Component } from 'react'

const TaggedGuests = React.createClass({
  render() {
    const { tags } = this.props;
    if (tags.length === 0) {
      return null;
    }
    return (
      <div className="tagged-guests">
        <i className="icon-tag" />
        <ul>
          {this.taggedGuestNodes()}
        </ul>
      </div>
    );
  },
  handleTagClick(user_id, e) {
    this.props.handleRemoveTaggedGuest(user_id);
  },
  taggedGuestNodes: function(users) {
    return this.props.tags.map((user, i) => {
      return (
        <li key={user.user_id}>
          {user.name}
          <i className="icon-cancel" onClick={this.handleTagClick.bind(this, user.user_id)} />
        </li>
      );
    });
  }
});

export default TaggedGuests;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/tag-guests/components/tagged-guests.es6